import { httpService } from '../helper';
import { constants } from '../constants';

export const getApplicationProgress = httpService().get.bind(this, `${constants.API.APPLICATION_PROGRESS}`);
export const postApplicationProgress = ({ step, status }) =>
  httpService().post(`${constants.API.APPLICATION_PROGRESS}?status=${status}&step=${step}`);
